import { useSessao } from '../lib/sessao'
import { Topo } from '../componentes/ui'
import { EquipeAcessos } from './EquipeAcessos'
import { AbaProfissionais } from './PecasCadastro'

/**
 * Gente.
 *
 * ─── DUAS LISTAS, E ELAS NÃO SÃO A MESMA ──────────────────────────
 *
 * `usuario_clinica` é quem tem LOGIN. `profissional` é quem ATENDE.
 * A sobreposição é grande e a diferença é o que importa:
 *
 *  · a recepcionista tem login e não atende;
 *  · a fisioterapeuta que cobre as terças atende e pode nunca ter
 *    entrado no sistema;
 *  · a dona costuma ser as duas coisas, e é `profissional.usuario_id`
 *    que amarra uma na outra.
 *
 * Estavam em telas diferentes — acessos em `/equipe`, profissionais
 * enterrados em `/ajustes › equipe` — e por isso ninguém achava onde
 * ligar o próprio cadastro ao próprio login. Agora é uma tela só, com
 * as duas listas à vista.
 */
export function Equipe() {
  const { pode } = useSessao()
  return (
    <>
      <Topo titulo="Equipe"
            subtitulo="Quem tem acesso ao sistema e quem atende paciente. São listas diferentes de propósito — e a mesma pessoa costuma estar nas duas." />
      <EquipeAcessos podeEditar={pode('usuario:write')} />
      <AbaProfissionais podeEditar={pode('config:write')} />
    </>
  )
}
